import { HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { dbGIStoStandardPage, PagedResults } from "@abaco/web-common/src/Paging";
import { SensorConfigItem } from "../models/SensorConfigModel";

export default class SensorConfigApi {
    private http: HTTPClient;
    private path: string;

    constructor(http: HTTPClient, path: string) {
        this.http = http;
        this.path = path;
    }

    public async getPhysicalQuantities(): Promise<string[]> {
        const res = await this.http.get(`/${this.path}/v1/physical-quantities`);

        return res.data;
    }

    public async getPhysicalQuantitesMappedForFarm(subjectId: number): Promise<string[]> {
        const res = await this.http.get(`/${this.path}/v1/physical-quantities/farm/${subjectId}`)
        return res.data;
    }

    public async insertPhysicalQuantities(object: SensorConfigItem): Promise<{ status: boolean; statusCode: number }> {
        let status = false;
        let statusCode = 500;
        const res = await this.http
            .post(`/${this.path}/v1/physical-quantities`, {
                physicalQuantity: object.physicalQuantity,
                stationCode: object.stationCode,
                sensorCode: object.sensorCode,
            })
            .then((e) => {
                status = true;
                statusCode = e.status;
            })
            .catch((error) => {
                status = false;
                statusCode = error.response.data.code;
            });

        if (status) {
            return { status, statusCode };
        } else {
            return { status, statusCode };
        }
    }

    public async updatePhysicalQuantities(object: SensorConfigItem): Promise<{ status: boolean; statusCode: number }> {
        let status = false;
        let statusCode = 500;
        const res = await this.http
            .put(`/${this.path}/v1/physical-quantities`, {
                physicalQuantity: object.physicalQuantity,
                stationCode: object.stationCode,
                sensorCode: object.sensorCode,
            })
            .then((e) => {
                status = true;
                statusCode = e.status;
            })
            .catch((error) => {
                status = false;
                statusCode = error.response.data.code;
            });

        if (status) {
            return { status, statusCode };
        } else {
            return { status, statusCode };
        }
    }

    public async deletePhysicalQuantities(object: SensorConfigItem): Promise<{ status: boolean; statusCode: number }> {
        let status = false;
        let statusCode = 500;
        const res = await this.http
            .delete(
                `/${this.path}/v1/physical-quantities/${object.physicalQuantity}/${object.stationCode}/${object.sensorCode}`
            )
            .then((e) => {
                status = true;
                statusCode = e.status;
            })
            .catch((error) => {
                status = false;
                statusCode = error.response.data.code;
            });
        if (status) {
            return { status, statusCode };
        } else {
            return { status, statusCode };
        }
    }

    public async getPhysicalQuantitiesMapped(stationsId: string): Promise<SensorConfigItem[]> {
        const res = await this.http.get(`/${this.path}/v1/physical-quantities/stations/${stationsId}`);

        return res.data;
    }
}
